module.exports = __webpack_public_path__ + "media/MyAudio_music.4bf9167b.mp3";